export default {
  // some env variables might be missing
  domain: process.env.REACT_APP_AUTH0_DOMAIN,
  clientID: process.env.REACT_APP_AUTH0_CLIENT_ID,
  redirectURI: process.env.REACT_APP_AUTH0_REDIRECT_URI,
  audience: process.env.REACT_APP_AUTH0_AUDIENCE,
  scope: process.env.REACT_APP_AUTH0_SCOPE,
  localLogoutOnly: process.env.REACT_APP_AUTH0_LOCAL_LOGOUT_ONLY === 'true',
};
